import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ConciliacaoService } from '../../../services/conciliacao.service';
import { ExibeCorrespondenciaDialogComponent } from '../../../../../../shared/dialogs/exibe-correspondencia-dialog/exibe-correspondencia-dialog.component';

interface CorrespondenciaComDiferenca {
  correspondenciaIndex: number;
  somaBanco: number;
  diferenca: number;
  qtdLancamentosBanco: number;
  qtdLancamentosCaixa: number;
}

@Component({
  selector: 'app-correspondencias-diferenca-dialog',
  standalone: false,
  templateUrl: './correspondencias-diferenca-dialog.component.html',
  styleUrl: './correspondencias-diferenca-dialog.component.scss'
})
export class CorrespondenciasDiferencaDialogComponent implements OnInit {

  correspondencias: CorrespondenciaComDiferenca[] = [];

  constructor(
    private conciliacaoService: ConciliacaoService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.carregarCorrespondencias();
  }

  private carregarCorrespondencias(): void {
    this.correspondencias = this.conciliacaoService.correspondenciasConciliacao
      .map((correspondencia, correspondenciaIndex) => {
        const somaBancoX100 = correspondencia.lancamentosBanco.reduce((soma, l) => soma + l.valorX100, 0);
        const somaCaixaX100 = correspondencia.lancamentosCaixa.reduce((soma, l) => soma + l.valorX100, 0);

        return {
          correspondenciaIndex,
          somaBanco: somaBancoX100 / 100,
          diferenca: (somaBancoX100 + somaCaixaX100) / 100,
          qtdLancamentosBanco: correspondencia.lancamentosBanco.length,
          qtdLancamentosCaixa: correspondencia.lancamentosCaixa.length,
        };
      })
      .filter(item => item.diferenca !== 0);
  }

  // Só é permitido desfazer quando essa conciliação está em modo de edição — em modo de
  // visualização (conciliação já finalizada/histórico) o botão só permite visualizar.
  public visualizarClick(item: CorrespondenciaComDiferenca): void {
    const acaoDesfazer = this.conciliacaoService.modoEdicao;

    const dialogRef = this.dialog.open(ExibeCorrespondenciaDialogComponent, {
      width: '1000px',
      maxWidth: '100vw',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      disableClose: acaoDesfazer,
      data: {
        acaoDesfazer,
        correspondenciaIndex: item.correspondenciaIndex,
      }
    });

    dialogRef.afterClosed().subscribe(() => this.carregarCorrespondencias());
  }
}
